import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { AiChatDataProviderFactory } from '../factory/AiChatDataProviderFactory';
import { AiChatBaseDataProvider } from '../dataProvider/AiChatBaseDataProvider';
import { AiChatData } from '../types';

export class AiChatRepository extends BaseWebComponentRepository {
  public dataProviderFactory: AiChatDataProviderFactory;
  public dataProvider: AiChatBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new AiChatDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<AiChatData> {
    return this.dataProvider.getDataForView();
  }
}
